import styled from 'styled-components';

const NavContent = styled.div`
  position: ${({ absolute }) => (absolute ? 'absolute' : 'relative')};
  overflow: hidden;
`;

export default NavContent;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HorizontallyNavigableContent/NavContent.jsx